import { c as _c } from "react/compiler-runtime";
import { Hint } from '@systemeio/ui';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import ButtonLikeLink from '../button-like-link';
import { getAccountRestrictedLink } from 'shared/utils/get-account-restricted-link';
import TransLoco from '../trans-loco';
import LinkWithoutPrefetch from '../link-without-prefetch';
export const RestrictionBanner = () => {
  const $ = _c(13);
  const {
    user,
    isRestrictedUser
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  if (!user) {
    return null;
  }
  if (!isRestrictedUser) {
    return null;
  }
  let t0;
  if ($[0] !== user?.dashboardLocale) {
    t0 = () => window.open(getAccountRestrictedLink(user?.dashboardLocale));
    $[0] = user?.dashboardLocale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("global.read_more");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <ButtonLikeLink onClick={t0}>{t1}</ButtonLikeLink>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      a: <LinkWithoutPrefetch href="/profile/user-plan" className="primary-link" />
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = <TransLoco t={t} i18nKey="dashboard.notifications.account_restricted" components={t3} />;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <div className="bg-danger/15 border-b-danger text-danger min-h-4 z-10 flex w-full items-center justify-center border-b px-4 py-1 sm:px-6 md:px-14"><span className="fill-danger flex flex-wrap items-center"><Hint className="flex-wrap" label={t2}>{t4}</Hint></span></div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};